export const getRelativeTime = (date: Date) => {
	const now = new Date();
	const secondsDiff = Math.floor((now.getTime() - date.getTime()) / 1000);
	if (secondsDiff < 60) return `${secondsDiff} ${secondsDiff === 1 ? 'second' : 'seconds'} ago`;
	const minutes = Math.floor(secondsDiff / 60);
	if (secondsDiff < 3600) return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
	const hours = Math.floor(secondsDiff / 3600);
	if (secondsDiff < 86400) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
	const days = Math.floor(secondsDiff / 86400);
	return `${days} ${days === 1 ? 'day' : 'days'} ago`;
};
